// 订单存在全部的选项的唯一标识都是id:25
export default {
  namespaced: true,
  state: {
    // 学员基础信息
    studentBaseInfo: {
      phoneNumber: null,
      studentName: null,
      studentBranchId: null,
      studentBranchTitle: null,
      studentSysShellId: null,
      sysShellIdNameTitle: null,
      actualName: null,
      qq: null,
      weChat: null,
      sex: null,
      idNumber: null,
      yearGraduate: null,
      grade: null,
      education: null,
      // 就读学校(前端输入框需要用到的参数)
      attendShowSchoolId: null,
      attendShowSchoolTitle: null,
      attendShowProfessionId: null,
      attendShowProfessionTitle: null,
      // 报考学校(前端输入框需要用到的参数)
      applyShowSchoolId: null,
      applyShowSchoolTitle: null,
      applyShowMajorId: null,
      applyShowMajorTitle: null,

      // 提供给后端的就读学校和专业
      currentSchool: null, // 学校名称
      currentProfession: null, // 专业名称
      attendSchool: null, // id

      // 提供给后端的报考学校和专业
      applySchool: null, // 学校名称
      applyMajor: null, // 专业名称
      collegeId: null, // id

      city: '',
      cityId: null,
      sourceChannelId: null,//来源渠道
      businessAccount: [],//关联业务号
      source: null,

      examYear: null,
      examMonth: null,
      registerUnit: null,
      registerJob: null,
      sysProvincesInfoId: null,
      applyUnit: null,
      applyPosition: null,
      intentSchool: null,
      intentFaculty: null,
      intentMajor: null,
      intendedTargetInstitutions: null,
      intendedTargetSpecialty: null,
      writtenCertificate: null,
      interviewCertificate: null,
      recommender: null,
      remark: null,
      mailingAddress: null,
      emergencyName: null,
      emergencyPhone: null,
      emergencyAddress: null,
      emergencyRelation: null,
      normalStudents: null,
      typeCertificate: null,
      interviewCondition: null,
      deliveryInfo: {
        acceptName: null,
        phone: null,
        areaId: null,
        address: null,
        areaTitle: null,
      },
      // 就读学校列表
      university: [],
      // 就读专业列表
      career: [],
      // 报考学校
      colleagesInfo: [],
      // 报考专业
      colleagesInfoCareer: [],
      currentEducation: null,
      classLocations: ['必填项效验的上课地点'],
      attributeIdCurrent: null,
      studentMarketAreaId: null,
      studentMarketAreaTitle: null,
      qualificationTypeName: null,
      schoolList: [], // 就读学校
      professionList: [], // 就读专业
      applySchoolList: [], // 报考学校
      applyProfessionList: [], // 报考专业
      crmMarketAreaTitle: null,
      coursePacketIds: []
    },

  },
  mutations: {



  },
  actions: {


  }
}